import React from 'react';
import {SVGProps} from '~/src/components/svg/SVGProps';

const NavProfile = ({primaryClassName, secondaryClassName, tertiaryClassName}: SVGProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path
            className={primaryClassName}
            d="M21.45,11.45a5.45,5.45,0,1,0-8.86,4.25A10,10,0,0,0,6,25.09V26H7.87V24.18h0A8.2,8.2,0,0,1,15.1,17V15a3.65,3.65,0,1,1,1.82,0v2a8,8,0,0,1,2.34.63L20,15.92l-.58-.22A5.42,5.42,0,0,0,21.45,11.45Z"
        />
        <path className={secondaryClassName} d="M20,15.92l-.73,1.67a8.15,8.15,0,0,1,4.87,6.59H14.18V26H26v-.91A10,10,0,0,0,20,15.92Z" />
        <rect className={tertiaryClassName} x="9.64" y="24.18" width="4.55" height="1.82" />
    </svg>
);

export default NavProfile;
